(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');

      this.setHeaderHeight();
      this.onScroll();

      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('resize', this.onResizeHandler);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    onScroll() {
      const scrolled = (window.pageYOffset || document.documentElement.scrollTop) > 4;

      if (scrolled === this.isScrolled) return;

      this.isScrolled = scrolled;
      this.classList.toggle('header-wrapper--scrolled', scrolled);
    }

    /*
      Part of the contract Dawn's own scripts expect from <sticky-header>.
      cart-notification.js calls it before opening the cart popup, so that the header
      the popup hangs from is on screen.

      This header is fixed and never hides, so there is nothing to restore and the
      method has nothing to do. It still has to exist: without it renderContents
      throws on this line and returns before it can open the notification, which is
      why the popup never appeared.
    */
    reveal() {}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
